import { TermsAndConditions } from './TermsAndConditions';

export const TermsScreen = () => {
  return <TermsAndConditions />;
};
